import type { TreeData } from '../../components/tree/useTreeApi';
import { roleSelectionListKeys } from '../types';
import type { TaxonomyLevelMetadata } from './taxonomyTree';
import type { ParentLinkedItem } from './treeToParentLinkedSelectionLists';
import { treeToParentLinkedSelectionLists } from './treeToParentLinkedSelectionLists';

// The top role level is named differently per consumer (reports `role_k7`,
// DataBuilder `job_category`); every level below it is identical.
export const DEFAULT_ROLE_TOP_LEVEL_KEY: string =
  roleSelectionListKeys[0] ?? 'role_k7';

/**
 * Flattens a role taxonomy tree into parent-linked selection lists keyed by the
 * FE role vocabulary.
 *
 * Keys each level off its ordinal `id` (1-7 → `roleSelectionListKeys[id - 1]`),
 * not the BE level tags (`role_k10 … role_k10000`) which diverge from the FE
 * keys at the ends — robust to tag renames and sparse level requests.
 */
export const treeToRoleSelectionLists = (
  treeData: readonly TreeData[],
  levels: readonly TaxonomyLevelMetadata[],
  { topLevelKey = DEFAULT_ROLE_TOP_LEVEL_KEY }: { topLevelKey?: string } = {}
): Partial<Record<string, ParentLinkedItem[]>> => {
  const keysByLevelOrdinal: string[] = [
    topLevelKey,
    ...roleSelectionListKeys.slice(1),
  ];

  return treeToParentLinkedSelectionLists(
    treeData,
    levels,
    (level) => keysByLevelOrdinal[level.id - 1] ?? null
  );
};
